/* Shared validation/submit helpers for price-match.js and contact-us-modal.js,
   so both forms validate and post the same way instead of duplicating it. */
window.PriceMatchUtils = (function () {
  const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function getStrings(root) {
    return {
      required: root.dataset.i18nRequired,
      invalidEmail: root.dataset.i18nInvalidEmail,
      invalidPrice: root.dataset.i18nInvalidPrice,
      priceTooHigh: root.dataset.i18nPriceTooHigh,
      invalidLink: root.dataset.i18nInvalidLink,
    };
  }

  function setFieldError(fieldWrapper, message) {
    const errorEl = fieldWrapper.querySelector('.modal-field__error');
    const input = fieldWrapper.querySelector('[data-field]');

    if (message) {
      fieldWrapper.setAttribute('data-invalid', '');
      if (input) input.setAttribute('aria-invalid', 'true');
      if (errorEl) errorEl.textContent = message;
    } else {
      fieldWrapper.removeAttribute('data-invalid');
      if (input) input.removeAttribute('aria-invalid');
      if (errorEl) errorEl.textContent = '';
    }
  }

  function validateForm(form, strings) {
    let firstInvalid = null;
    let isValid = true;

    form.querySelectorAll('[data-modal-field]').forEach((fieldWrapper) => {
      const input = fieldWrapper.querySelector('[data-field]');
      if (!input) return;

      const value = input.value.trim();
      let message = '';

      if (input.hasAttribute('required') && value === '') {
        message = strings.required;
      } else if (input.type === 'email' && value !== '' && !EMAIL_PATTERN.test(value)) {
        message = strings.invalidEmail;
      }

      setFieldError(fieldWrapper, message);
      if (message) {
        isValid = false;
        firstInvalid = firstInvalid || input;
      }
    });

    if (firstInvalid) firstInvalid.focus();
    return isValid;
  }

  function serializeForm(form) {
    const data = {};
    form.querySelectorAll('[data-field]').forEach((field) => {
      data[field.dataset.field] = field.value.trim();
    });
    return data;
  }

  function setSubmitLoading(button, isLoading) {
    if (!button) return;
    button.classList.toggle('loading', isLoading);
    button.disabled = isLoading;
    const spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  function setStatus(statusEl, status, message) {
    if (!statusEl) return;
    statusEl.textContent = message || '';
    if (status) {
      statusEl.setAttribute('data-status', status);
    } else {
      statusEl.removeAttribute('data-status');
    }
  }

  async function postJSON(url, payload) {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    });

    let data = null;
    try {
      data = await response.json();
    } catch (error) {
      data = null;
    }

    if (!response.ok) {
      // Deliberately not surfacing data.error here: on the price-match API
      // that field is a raw validation/rejection dump (e.g. a multi-line Zod
      // error), never customer-facing copy. Leaving the message empty lets
      // the caller's `error.message || i18nGenericError` fall through to the
      // polished, localized generic-error string instead of showing that
      // raw text — or, before this fix, the literal unlocalized "Request
      // failed" that used to always win here since this API has no
      // `message` field.
      throw new Error((data && data.message) || undefined);
    }

    return data || {};
  }

  return {
    getStrings,
    validateForm,
    setFieldError,
    serializeForm,
    setSubmitLoading,
    setStatus,
    postJSON,
  };
})();
